export const environment = {
  production: false,
  sentry_env: 'dev',
  env: 'dev',
  version: '1.0.0',
  logging: 'warn', // debug, info, warn, error
  API_URL: 'https://dev.enterprise.api.treesoflives.com',
  APP_URL: 'https://dev.enterprise.treesoflives.com',
  AWS_REGION: 'us-east-1',
  API_SERVICE: 'execute-api',
  IDENTITY_POOL_ID: 'us-east-1:757fb249-a57e-4b7c-8c5f-cc40c57eaef0',
  USER_POOL_ID: 'us-east-1_RtEUOLcjS',
  USER_POOL_WEB_CLIENT_ID: '24ojmkg55eg5to5sv7ugsshola',
  API_NAME: 'api',
  origin: 'https://dev.enterprise.treesoflives.com',
  SENTRY_DSN: 'https://6038cbf0eb2349ea96f086fc05853508@o490175.ingest.sentry.io/4505363824705536',
};
